import classNames from 'classnames'

import { Account } from './Account'

import styles from './SymbiosisInput.pcss'

interface Props {
	address?: string | null
	className?: string
	disabled?: boolean
	endAdornment?: React.ReactNode
	inputStyle?: string
	helperText?: React.ReactNode
	label: string
	networkIcon?: string
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
	placeholder?: string
	startAdornment?: React.ReactNode
	step?: string | number
	type?: React.HTMLInputTypeAttribute
	value?: string
}

export function SymbiosisInput({
	address,
	className,
	disabled,
	endAdornment,
	inputStyle,
	helperText,
	label,
	networkIcon,
	onChange,
	placeholder,
	startAdornment,
	step,
	type,
	value,
}: Props) {
	return (
		<div className={classNames(styles.container, className)}>
			<div className={styles.header}>
				<div className={styles.label}>{label}</div>
				{address && (
					<Account address={address} networkIcon={networkIcon} />
				)}
			</div>

			<div className={classNames(styles.content, inputStyle)}>
				{startAdornment}
				<input
					className={styles.input}
					disabled={disabled}
					onChange={onChange}
					placeholder={placeholder}
					step={step}
					type={type}
					value={value}
				/>
				{endAdornment}
			</div>

			{!!helperText && (
				<div className={styles.helperText}>{helperText}</div>
			)}
		</div>
	)
}
